export default {
    phone:/^1[3|4|5|7|8][0-9]\d{8}$/,
    special:/[@#\$%\^&\*]+/g,
    txt:/^(([\u4e00-\u9fa5]{2,8})|([a-zA-Z]{2,16}))$/
}



// WEBPACK FOOTER //
// ./src/api/reg.js